import { useMemo } from 'react';

import useSWR from 'swr';

import { getEnv, fetchWithToken } from '@adsk/acs-sc-web-platform-api';
import { useCurrentProjectId } from '@adsk/alloy-provider';

import { BE_CONFIG } from '../helpers/consts';

function usePermission(productAllowed = false) {
  const projectId = useCurrentProjectId();
  const url = useMemo(() => {
    const env = getEnv();
    const baseUrl = BE_CONFIG[env];
    return `${baseUrl}/v1/projects/${projectId}/permissions/current`;
  }, [projectId]);

  const { data } = useSWR(productAllowed ? url : null, fetchWithToken, {
    shouldRetryOnError: false,
    revalidateOnMount: true,
    revalidateOnFocus: false,
  });

  return {
    permission: data,
  };
}
export default usePermission;
